import * as React from 'react';
import { useTranslation } from 'react-i18next';import { AuthA11yToggle as SharedAuthA11yToggle } from '@monorepo/shared-lib';

interface AuthA11yToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  placement?: 'header' | 'footer';
}

/** GT wrapper: shared toggle with i18n labels. */
export const AuthA11yToggle: React.FC<AuthA11yToggleProps> = ({
  checked,
  onChange,
  placement = 'footer',
}) => {
  const { t } = useTranslation();

  return (
    <SharedAuthA11yToggle
      checked={checked}
      onChange={onChange}
      placement={placement}
      label={t('login.accessibility-mode')}
      helpText={t('login.accessibility-mode-help')}
    />
  );
};
